// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"5cc5110f","125":"85a18f8a","324":"d13c632d","379":"ba20dee5","529":"80430034","579":"49e2191d","812":"bc1bb4a9"}[chunkId] + ".chunk.js";
};